import React from 'react';
import { Box } from '@mui/material';
import { MetricDisplay } from '../atoms/MetricDisplay';
import { formatCurrencyWhole } from '../../../../../shared/utils/currency';

interface FinancialSummaryRowProps {
  approved: number;
  booked: number;
  remaining: number;
}

export const FinancialSummaryRow: React.FC<FinancialSummaryRowProps> = ({
  approved,
  booked,
  remaining,
}) => {
  // Determine color for remaining based on value
  const remainingColor = remaining < 0 ? 'error.main' : 'success.main';

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <MetricDisplay
          label="Approved"
          value={formatCurrencyWhole(approved)}
          color="success.main"
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <MetricDisplay
          label="Booked"
          value={formatCurrencyWhole(booked)}
          color="warning.main"
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <MetricDisplay
          label="Remaining"
          value={formatCurrencyWhole(remaining)}
          color={remainingColor}
        />
      </Box>
    </Box>
  );
};
